
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"42","height":"31","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M40.34 2.99a1.34 1.34 0 00-1.335-1.336H2.929A1.34 1.34 0 001.592 2.99v25.387a1.34 1.34 0 001.337 1.336h36.076a1.34 1.34 0 001.336-1.336V2.99z","fill":"#fff"}}),_c('path',{attrs:{"d":"M3.597 3.658v23.383H1.592v1.336c0 .739.599 1.336 1.337 1.336h36.076a1.34 1.34 0 001.336-1.336V3.658H3.597z","fill":"#ECEFF1"}}),_c('path',{attrs:{"d":"M39.005 30.381h-2.673a.668.668 0 010-1.336h2.673a.67.67 0 00.668-.668V2.99a.67.67 0 00-.668-.668H2.929a.67.67 0 00-.668.668v25.387c0 .367.299.668.668.668h33.95a.668.668 0 010 1.336H2.929c-1.105 0-2.005-.899-2.005-2.004V2.99c0-1.105.9-2.004 2.005-2.004h36.076c1.105 0 2.004.9 2.004 2.004v25.387c0 1.105-.9 2.004-2.004 2.004z","fill":"#455A64"}}),_c('path',{attrs:{"d":"M17.626 27.709H1.592a.668.668 0 010-1.336h16.034a.668.668 0 010 1.336zM20.298 27.709a.663.663 0 01-.668-.668c0-.174.066-.348.187-.47a.689.689 0 01.948-.013c.134.136.2.31.2.483a.627.627 0 01-.2.468.627.627 0 01-.467.2z","fill":"#455A64"}}),_c('circle',{attrs:{"cx":"7.378","cy":"7.378","r":"7.378","transform":"matrix(1 0 0 -1 14.531 23.686)","fill":"#BDCAD0"}}),_c('path',{attrs:{"d":"M24.048 14.818a1 1 0 010 1.732l-3.579 2.066a1 1 0 01-1.5-.866v-4.133a1 1 0 011.5-.866l3.579 2.067z","fill":"#455A64"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M30.005 15.684a8.72 8.72 0 10-17.439 0 8.72 8.72 0 0017.44 0zm-8.72-7.576a7.576 7.576 0 110 15.151 7.576 7.576 0 010-15.151z","fill":"#455A64"}})])
          )
        }
      }
    